import type { ReadonlyDeep } from 'type-fest';

import { ResolvableServiceInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import { costUsageForm2ApiMapper } from '../../CostUsage/mappers/cost-usage.form2api.mapper';
import { materialUsageForm2ApiMapper } from '../../MaterialUsage/mappers/material-usage.form2api.mapper';
import { codingConfigForm2ApiMapper } from '../../CodingConfig/mappers/coding-config.form2api.mapper';

import type { ResolvableServiceInput as IResolvableServiceInput } from '../hooks/useCreateResolvableServiceMutation.hook';
import type { ResolvableServiceForm_ResolvableServiceBaseInterface } from '../fragments/resolvable-service-base-interface.fragment';

import { resolvableServiceValueForm2ApiMapper } from './resolvable-service-value.form2api.mapper';

export function resolvableServiceForm2ApiMapper(
  resolvableService: ReadonlyDeep<ResolvableServiceForm_ResolvableServiceBaseInterface>,
): ReadonlyDeep<IResolvableServiceInput> {
  const resolvableServiceInput = pruneInput(
    resolvableService,
    ResolvableServiceInput,
  );

  return {
    ...resolvableServiceInput,
    value: resolvableServiceValueForm2ApiMapper(resolvableService.value),
    costUsages: resolvableService.costUsages.map(costUsageForm2ApiMapper),
    materialUsages: resolvableService.materialUsages.map(
      materialUsageForm2ApiMapper,
    ),
    codingConfig: codingConfigForm2ApiMapper(resolvableService.codingConfig),
  };
}
